import { render, staticRenderFns } from "./DocumentTemplateSelect.vue?vue&type=template&id=9ce7d546&scoped=true"
import script from "./DocumentTemplateSelect.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce7d546",
  null
  
)

export default component.exports